import { render, staticRenderFns } from "./CompositionList.vue?vue&type=template&id=301c2368&"
import script from "./CompositionList.vue?vue&type=script&lang=js&"
export * from "./CompositionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports